import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=1226874e&scoped=true"
import script from "./SliderInput.vue?vue&type=script&lang=ts"
export * from "./SliderInput.vue?vue&type=script&lang=ts"
import style0 from "./SliderInput.vue?vue&type=style&index=0&id=1226874e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226874e",
  null
  
)

export default component.exports